import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import App from '@/components/App/App';
import Login from '@/components/UserManagement/Login';
import { Dashboard } from '@/components/Dashboard/Dashboard';
import ViewsRoutes from '@/components/UserManagement/ViewsRoutes';
import ErrorPage from '@/components/Common/ErrorPage';
import ResetPwd from '@/components/UserManagement/ResetPassword';
import ActivateUser from '@/components/UserManagement/ActivateUser'
import UserProfile from '@/components/Header/UserProfile'
import Settings from '@/components/Settings/Settings';
import ShipmentsSetting from '@/components/Settings/ShipmentsSetting';
import Territories from '@/components/Settings/Territories/Territories';
import OptimizationSetting from '@/components/Settings/OptimizationSetting'
import GeneralSetting from '@/components/Settings/GeneralSetting'
import { SettingsProvider } from '@/components/Settings/SettingsContext';
import VehicleEditor from '@/components/VehicleEditor/VehicleEditor';
import RoutesListMap from '@/components/Routes/RouteListMap/Routes';
import VehicleRoutes from '@/components/Routes/RouteListMap/VehicleRoutes';
import { EditModeProvider } from '@/contexts/EditModeContext';
import {
  ROUTES,
  TIMELINE,
  DASHBOARD,
  ROUTE_ID,
  process_id,
  LOGIN,
  RESET_PWD,
  ACTIVATE_USER,
  USER_PROFILE,
  SHIPMENTS_SETTING,
  OPTIMIZATION_SETTING,
  GENERAL_SETTING,
  SETTINGS_PAGE,
  VEHICLE_EDITOR,
  TERRITORY,
  ROUTELIST
} from '@/config/paths';
import { CustomTimeline } from '@/components/Routes/CustomTimeline';
import { InteractivePage } from '@/components/Interactive/InteractivePage';


export const Routing = () => {
  const { instance: { customername } } = window;

  return (<Routes>
    <Route path={`/${customername}${LOGIN}`} element={<Login />} />
    <Route path={`/${customername}${RESET_PWD}`} element={<ResetPwd />} />
    <Route path={`/${customername}${ACTIVATE_USER}`} element={<ActivateUser />} />
    <Route path={`/${customername}`} element={
      <EditModeProvider>
        <SettingsProvider>
          <App />
        </SettingsProvider>
      </EditModeProvider>
    }>
      <Route
        path={`/${customername}/${SETTINGS_PAGE}/${VEHICLE_EDITOR}`}
        element={<VehicleEditor />}
      />
      <Route
        path={`/${customername}/${SETTINGS_PAGE}/${TERRITORY}`}
        element={<Territories />} />
      <Route path={`${USER_PROFILE}`} element={<UserProfile />} />
      <Route path={`/${customername}`} element={<Navigate replace to={`/${customername}${DASHBOARD}`} />} />
      <Route path="/routes/:vehicleName" element={<VehicleRoutes />} />
      <Route path={`${DASHBOARD}`} element={<Dashboard />}>
        <Route path={`${process_id}`}>
          <Route index element={<Dashboard />} />
          <Route path={`${process_id}`} element={<Dashboard />} />
        </Route>
      </Route>
      <Route path={`${ROUTES}`} element={<ViewsRoutes />}>
        <Route path={`${TIMELINE}`} element={<CustomTimeline />}>
          <Route path={`${process_id}`}>
            <Route index element={<CustomTimeline />} />
            <Route path={`${process_id}`} element={<CustomTimeline />} />
          </Route>
        </Route>
        <Route path={`${ROUTELIST}`} element={<RoutesListMap />}>
          <Route path={`${process_id}`}>
            <Route index element={<RoutesListMap />} />
            <Route path={`${process_id}`} element={<RoutesListMap />} />
          </Route>
        </Route>
        <Route path={`${ROUTE_ID}`}>
        </Route>
      </Route>
      <Route path={`${SETTINGS_PAGE}`}
        element={<Settings />}
      >
        <Route path={`${SHIPMENTS_SETTING}`} element={<ShipmentsSetting />} />
        <Route path={`${OPTIMIZATION_SETTING}`} element={<OptimizationSetting />} />
        <Route path={`${GENERAL_SETTING}`} element={<GeneralSetting />} />
      </Route>
      {/* The id is nested, not a sibling route, so navigating /interactive →
          /interactive/:processId keeps InteractivePage mounted. A sibling would
          remount it and tear down the MFE's React root on every process switch. */}
      <Route path="interactive" element={<InteractivePage />}>
        <Route path={`${process_id}`} />
      </Route>
    </Route>
    <Route path="*" element={<ErrorPage />} />
  </Routes>);
};
